import React from 'react';
import AsientosForm from '../components/AsientosForm';

const IngresoManual = ({ token, id_company }) => {
    return (
        <div>
            <h1>Ingreso Manual de Asientos Contables</h1>
            <AsientosForm token={token} id_company={id_company} />
        </div>
    );
};

export default IngresoManual;
